import { Component, Input } from '@angular/core';
import { HarvestActivityReportStatus } from '../../local-db/objects/harvest-activity-report';

@Component({
  selector: 'app-report-status-dot',
  standalone: false,
  templateUrl: './report-status-dot.component.html',
  styleUrl: './report-status-dot.component.scss'
})
export class ReportStatusDotComponent {
  @Input() status: HarvestActivityReportStatus
  protected readonly HarvestActivityReportStatus = HarvestActivityReportStatus;
}
